import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducers";
import {configureStore,} from "@reduxjs/toolkit";
import rootSaga from "./sagas";
import {logger} from "redux-logger";
import {ENV} from "../constants";

const sagaMiddleware = createSagaMiddleware();

// Build middleware array conditionally based on environment
const buildMiddleware = (getDefaultMiddleware: any) => {
    const middleware = getDefaultMiddleware({ thunk: false });
    
    // Only add logger in development/non-prod environments
    if (ENV.ENABLE_REDUX_LOGS) {
        middleware.push(logger);
    }
    
    // Always add saga middleware
    middleware.push(sagaMiddleware);
    
    return middleware;
};

export const store = configureStore({
    reducer: rootReducer,
    middleware: buildMiddleware,
    devTools: ENV.ENV_MODE !== 'prod', // Enable devTools only in non-prod environments
});

sagaMiddleware.run(rootSaga);
//
// // // assigning store to next wrapper
// const makeStore = () => store;
// //
// export const wrapper = createWrapper(makeStore);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
